import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'
import { useReactiveVar } from '@apollo/client'
import { sidebarExpandedVar } from '@@partner:graphql/initial-data'
import { useFetchBrandInfo } from '@@partner:graphql/query/brand/currentBrandInfo.gql'

import { NavLink, generatePath } from 'react-router-dom'
import { Nav, Sidenav, Whisper, Tooltip } from 'rsuite'

import ListIcon from '@rsuite/icons/List'
import TableIcon from '@rsuite/icons/Table'
import BranchIcon from '@rsuite/icons/Branch'
import Car from '@rsuite/icons/legacy/Car'
import CheckRoundIcon from '@rsuite/icons/CheckRound'
import TreeIcon from '@rsuite/icons/Tree'
import SpeakerIcon from '@rsuite/icons/Speaker'
import OperatePeopleIcon from '@rsuite/icons/OperatePeople'
import SettingHorizontalIcon from '@rsuite/icons/SettingHorizontal'
import PageNextIcon from '@rsuite/icons/PageNext'
import Peoples from '@rsuite/icons/Peoples'
import Book2 from '@rsuite/icons/legacy/Book2'
import BarChartIcon from '@rsuite/icons/BarChart'

import {
  ROUTE_SETTINGS,
  ROUTE_BRAND_SETTINGS,
  ROUTE_SHOPS,
  ROUTE_CATALOG,
  ROUTE_ORDERS,
  ROUTE_USERS_MANAGEMENT,
  ROUTE_MARKETING_MANAGEMENT,
  ROUTE_ASSEMBLING_MANAGEMENT,
  ROUTE_CUSTOMERS,
  ROUTE_TEXT_MATERIALS_MANAGEMENT,
  ROUTE_LOGISTIC_DASHBOARD,
  ROUTE_REPORTS
} from '@@partner:config/routes'

import './AppSidebar.scss'

export default function AppSidebar () {
  const isExpanded = useReactiveVar(sidebarExpandedVar)
  const { brandSlug, partnerInfo } = usePartner()
  const { data } = useFetchBrandInfo()

  const canViewBlock = (permission: string) => !partnerInfo.settings?.permissions || partnerInfo.settings?.permissions.includes(permission)

  const renderNavContent = () => (
    <Nav>
      {brandSlug && (
        <>
          { canViewBlock('customers') && (
            <Nav.Item
              as={NavLink}
              activeClassName="is-active"
              icon={<Peoples />}
              to={generatePath(ROUTE_CUSTOMERS, { brandSlug })}
            >
              Покупатели
            </Nav.Item>
          )}
          { canViewBlock('orders') && (
            <Nav.Item
              as={NavLink}
              activeClassName="is-active"
              icon={<ListIcon />}
              to={generatePath(ROUTE_ORDERS, { brandSlug })}
            >
              Заказы
            </Nav.Item>
          )}
          { canViewBlock('orders') && (
            <Nav.Item
              as={NavLink}
              activeClassName="is-active"
              to={generatePath(ROUTE_ASSEMBLING_MANAGEMENT, { brandSlug })}
              icon={<CheckRoundIcon />}
            >
              Сборка
            </Nav.Item>
          )}
          { canViewBlock('catalog') && (
            <Nav.Item
              as={NavLink}
              activeClassName="is-active"
              icon={<TableIcon />}
              to={generatePath(ROUTE_CATALOG, { brandSlug })}
            >
              Каталог
            </Nav.Item>
          )}
          { canViewBlock('settings') && (
            <Nav.Item
              as={NavLink}
              activeClassName="is-active"
              to={generatePath(ROUTE_BRAND_SETTINGS, { brandSlug })}
              icon={<BranchIcon />}
            >
              Бренд
            </Nav.Item>
          )}
          { canViewBlock('shops') && (
            <Nav.Item
              as={NavLink}
              activeClassName="is-active"
              to={generatePath(ROUTE_SHOPS, { brandSlug })}
              icon={<TreeIcon />}
            >
              Магазины
            </Nav.Item>
          )}
          { canViewBlock('logistics') && (
            <Nav.Item
              as={NavLink}
              activeClassName="is-active"
              to={generatePath(ROUTE_LOGISTIC_DASHBOARD, { brandSlug })}
              icon={<Car />}
            >
              Логистика
            </Nav.Item>
          )}
        </>
      )}
      { canViewBlock('users') && (
        <Nav.Item
          as={NavLink}
          activeClassName="is-active"
          to={generatePath(ROUTE_USERS_MANAGEMENT)}
          icon={<OperatePeopleIcon />}
        >
          Сотрудники
        </Nav.Item>
      )}

      {brandSlug && canViewBlock('marketing') && (
        <Nav.Item
          as={NavLink}
          activeClassName="is-active"
          to={generatePath(ROUTE_MARKETING_MANAGEMENT, { brandSlug })}
          icon={<SpeakerIcon />}
        >
          Маркетинг
        </Nav.Item>
      )}

      {brandSlug && canViewBlock('reports') && (
        <Nav.Item
          as={NavLink}
          activeClassName="is-active"
          to={generatePath(ROUTE_REPORTS, { brandSlug })}
          icon={<BarChartIcon />}
        >
          Отчеты
        </Nav.Item>
      )}

      {brandSlug && canViewBlock('textMaterials') && (
        <Nav.Item
          as={NavLink}
          activeClassName="is-active"
          to={generatePath(ROUTE_TEXT_MATERIALS_MANAGEMENT, { brandSlug })}
          icon={<Book2 />}
        >
          Контент
        </Nav.Item>
      )}
      
      { canViewBlock('settings') && (
        <Nav.Item
          as={NavLink}
          activeClassName="is-active"
          to={generatePath(ROUTE_SETTINGS)}
          icon={<SettingHorizontalIcon />}
        >
          Настройки
        </Nav.Item>
      )}
    </Nav>
  )

  return (
    <div className="AppSidebar__Container AppSidebar__Desktop">
      <Sidenav
        expanded={isExpanded}
        style={{ overflowY: 'auto', width: isExpanded ? 260 : 56 }}
        className="AppSidebar"
      >
        <Sidenav.Header className="AppSidebar__Header">
          <Whisper
            trigger="hover"
            speaker={<Tooltip>Развернуть/свернуть меню</Tooltip>}
          >
            <PageNextIcon
              style={{ fontSize: '2em' }}
              className={`w-full mt-4 text-white transform transition-transform delay-200 duration-300 align-middle ${
                isExpanded ? 'rotate-180' : 'rotate-0'
              }`}
              role="button"
              onClick={() => sidebarExpandedVar(!isExpanded)}
            />
          </Whisper>
        </Sidenav.Header>
        <Sidenav.Body>
          {renderNavContent()}
        </Sidenav.Body>
      </Sidenav>
    </div>
  )
}
